import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AdminService } from '../../services/admin.service';
import { User } from '../../models/user';
import { Subject, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, tap, catchError } from 'rxjs/operators';

@Component({
  selector: 'app-admin-user-search',
  templateUrl: './admin-user-search.component.html'
})
export class AdminUserSearchComponent implements OnInit {
  @Output() searchResults = new EventEmitter<User[]>();
  users: User[] = [];
  private searchTerms = new Subject<string>();
  loading = false;
  searchInitiated = false;

  constructor(private user: AdminService) {}

  ngOnInit() {
    this.searchTerms.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(term => {
        this.searchInitiated = true;
        if (!term.trim()) { 
          this.users = [];
          this.loading = false;
          this.searchResults.emit([]);
          return;
        }
        this.loading = true;
      }),
      switchMap((term: string) => 
        term.trim() ? this.user.search<Array<User>>(term.toLowerCase()).toPromise() : of([])
      ),
      tap(() => this.loading = false),
      catchError(error => {
        console.error(error);
        this.loading = false;
        return of([]);
      })
    ).subscribe(users => {
      this.users = users;
      this.searchResults.emit(users);
    });
  }

  search(val: string): void {
    this.searchTerms.next(val);
  }
}